import { Controller } from "@hotwired/stimulus";

/**
 * GO4S DS — déclencheur de démonstration d'un toast (catalogue).
 */
export default class extends Controller {
  static values = { tone: String, title: String, message: String };

  fire() {
    if (window.g4sToast) {
      window.g4sToast({ tone: this.toneValue, title: this.titleValue, message: this.messageValue });
    }
  }
}
